import React, {useCallback} from 'react';
import Skeleton from 'react-loading-skeleton'
const MaskedInput = React.lazy(()=>import('react-input-mask'))

function Input(props) {
  const onChange = props.onChange
  const changed = useCallback((e)=>{
    if(onChange){
      onChange(e.target.value)
    }
  },[onChange])
  if(props.mask){
    return <React.Suspense fallback={<Skeleton height={36.5}/>}>
      <MaskedInput
          className={"form-control"}  {...props}
          mask={props.mask} maskChar={"_"}
          onChange={changed}/>
    </React.Suspense>
  }
  return (
      <>
        <input className={"form-control"} {...props} onChange={changed}/>
      </>
  );
}

export default Input;
